import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { useModal } from "../../../../../contexts/modalContext/modalContext";
import Button from "../../../../Elements/Button/Button";
import Icon from "../../../../Elements/Icon/Icon";

import styles from "./styles.module.scss";

const DowngradeNotAllowedModal = () => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();

  return (
    <div className={styles.downgradeNotAllowedModal}>
      <Icon name="warning" red iconClass={styles.icon} />
      <div className={styles.title}>
        {getTextByKey("downgrade-not-allowed-title")}
      </div>
      <div className={styles.description}>
        {getTextByKey("downgrade-not-allowed-description")}
      </div>
      <div className={styles.actions}>
        <Button className="new-button" onClick={closeModal}>
          {getTextByKey("close")}
        </Button>
      </div>
    </div>
  );
};

export default DowngradeNotAllowedModal;
